import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import ContactHero from "./components/ContactHero";
import ContactInfoSection from "./components/ContactInfoSection";
import ContactForm from "./components/ContactForm";
import { usePageMeta } from "../../hooks/usePageMeta";

export default function ContactPage() {
  usePageMeta(
    "Contact | StackMap Systems",
    "Get in touch with the StackMap team. Request a demo, ask about pricing, or discuss bespoke development needs."
  );

  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#form") {
      const timer = setTimeout(() => {
        const el = document.getElementById("form-section");
        if (el) {
          const y = el.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 100);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-graphite-900">
      <Navbar />
      <main>
        <ContactHero />
        <section id="form-section" className="py-12 md:py-20 scroll-mt-24">
          <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
            <div className="max-w-5xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
                <ContactInfoSection />
                <ContactForm />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
